import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { orchestrator } from 'satcheljs';
import { onRoomAdded, updateLocations } from 'owa-calendar-compose-form-actions';
import { createEnhancedLocationFromRoomInfo, containsLocation } from 'owa-location-persona';
import { createLocationMetricsFromRoomInfo } from 'owa-calendar-helpers-types/lib/utils/createLocationMetrics';
import { addLocationMetrics } from 'owa-calendar-compose-form-store/lib/mutators/eventMetricsMutators';

export default orchestrator(onRoomAdded, actionMessage => {
    const { name, emailAddress } = actionMessage;
    const { event } = getComposeStore();

    const newEnhancedLocation = createEnhancedLocationFromRoomInfo(name, emailAddress);

    if (!containsLocation(event.Locations, newEnhancedLocation)) {
        updateLocations([...event.Locations, newEnhancedLocation]);
        addLocationMetrics(createLocationMetricsFromRoomInfo(name, emailAddress, 'RoomPanel'));
    }
});
